export class CivilStatus {
  id: number;
  name: string;
  description: string;
}



// WEBPACK FOOTER //
// ./src/app/models/civil-status.model.ts